module.exports = __webpack_public_path__ + "static/media/PA-Icon-Staubsauger-pos.cf4a70b6.svg";